const MenuIcon = () => (
  <svg width="29" height="24" viewBox="0 0 29 24" fill="none">
    <path
      d="M0.5 19.8894L0.5 18.6052L10.9327 18.6052L10.9327 19.8894L0.5 19.8894Z"
      fill="currentColor"
    />
    <path
      d="M0.500977 10.751L0.500976 9.46673L10.9337 9.46673L10.9337 10.751L0.500977 10.751Z"
      fill="currentColor"
    />
    <path
      d="M0.500977 1.61218L0.500976 0.32794L26.5828 0.327941L26.5828 1.61218L0.500977 1.61218Z"
      fill="currentColor"
    />
    <path
      d="M19.3673 7.58411C15.7757 7.58411 12.8506 10.5268 12.8506 14.14C12.8506 17.7532 15.7757 20.6959 19.3673 20.6959C20.9291 20.6959 22.3632 20.138 23.4873 19.2119L27.3782 23.1262C27.4382 23.1891 27.5101 23.2394 27.5897 23.274C27.6693 23.3086 27.755 23.3269 27.8417 23.3278C27.9284 23.3286 28.0144 23.3121 28.0946 23.2791C28.1749 23.2462 28.2478 23.1974 28.3092 23.1357C28.3705 23.0741 28.4189 23.0007 28.4517 22.92C28.4845 22.8392 28.5009 22.7527 28.5 22.6655C28.4991 22.5782 28.4809 22.4921 28.4466 22.412C28.4122 22.3319 28.3622 22.2596 28.2997 22.1992L24.4088 18.2848C25.3293 17.154 25.8839 15.7112 25.8839 14.14C25.8839 10.5268 22.9588 7.58411 19.3673 7.58411ZM19.3673 8.89529C22.2546 8.89529 24.5806 11.2353 24.5806 14.14C24.5806 17.0447 22.2546 19.3847 19.3673 19.3847C16.4799 19.3847 14.1539 17.0447 14.1539 14.14C14.1539 11.2353 16.4799 8.89529 19.3673 8.89529Z"
      fill="currentColor"
    />
  </svg>
)

export default MenuIcon
